/**
 * Chart Header Component Constants
 * All magic numbers and configuration values
 */

/**
 * Layout and Spacing Constants
 */
export const CHART_HEADER_CONSTANTS = {
  /** Main container padding */
  CONTAINER_PADDING: 5,

  /** Margin bottom for header */
  CONTAINER_MARGIN_BOTTOM: 2,

  /** Gap between metric items */
  METRICS_GAP: 10,

  /** Gap for responsive layout */
  RESPONSIVE_GAP: {
    xs: 5,
    md: 0,
  },

  /** Padding for metrics container */
  METRICS_PADDING: {
    xs: 0,
    md: 4,
  },

  /** Individual metric gap */
  METRIC_ITEM_GAP: 1,
} as const;

/**
 * Typography Constants
 */
export const TYPOGRAPHY_CONFIG = {
  /** Metric label text size */
  METRIC_LABEL_SIZE: 12,

  /** Animated currency font size */
  CURRENCY_FONT_SIZE: 24,

  /** Font weight for currency */
  CURRENCY_FONT_WEIGHT: 500,

  /** Currency symbol */
  CURRENCY_SYMBOL: '$',

  /** Currency letter spacing */
  CURRENCY_LETTER_SPACING: '0.036px',
} as const;

/**
 * Component Configuration
 */
export const COMPONENT_CONFIG = {
  /** Show currency animation */
  SHOW_ANIMATION: true,

  /** Use compact currency format */
  COMPACT_CURRENCY: true,

  /** Currency font style */
  CURRENCY_FONT_STYLE: 'normal',

  /** Show tooltip icon */
  SHOW_TOOLTIP_ICON: true,
} as const;

/**
 * Responsive Breakpoints
 */
export const BREAKPOINTS = {
  /** Mobile to desktop breakpoint */
  MOBILE_DESKTOP: 'md',
} as const;
